<script setup lang="ts">
import CourseSectionsView from '../../views/CourseSectionsView/CourseSectionsView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <suspense>
      <div class="col fit">
        <CourseSectionsView
          :user-course-doc-id="$route.params?.userCourseDocId as string"
        />
      </div>
    </suspense>
  </BPage>
</template>
